import styled from 'styled-components'

import { theme } from 'styles/theme'

const { colors, media, radii, space } = theme

export const Section = styled.section`
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  width: 100%;
  overflow: hidden;
  background-color: ${colors['cashme-dark-blue']};
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
  gap: ${space['spacing-lg']};
  padding: ${space['spacing-xl']} 8.5rem ${space['spacing-xxl']};

  @media (${media.phone}) {
    padding: ${space['spacing-xl']} ${space['spacing-md']} ${space['spacing-xxl']};
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-sm']};
`

export const Controls = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space['spacing-md']};
`

export const SocialButtons = styled.div`
  display: flex;
  align-items: center;
  gap: ${space['spacing-xs']};
`

export const SocialButton = styled.button<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4.5rem;
  height: 3.${space['spacing-xxl']};
  padding: 0;
  border: 1px solid ${colors['cyan-text-contrast']};
  border-radius: ${radii['corner-radius-md']};
  background-color: ${({ $active }) => ($active ? colors['cyan-text-contrast'] : 'transparent')};
  cursor: pointer;
  transition: background-color 0.2s ease;

  svg {
    width: 1.25rem;
    height: auto;
  }
`

export const Arrows = styled.div`
  display: flex;
  gap: ${space['spacing-xs']};

  @media (${media.phone}) {
    display: none;
  }
`

export const Arrow = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${space['spacing-xl']};
  height: ${space['spacing-xl']};
  padding: 0;
  border: 1px solid ${colors['cyan-text-contrast']};
  border-radius: ${radii['corner-radius-circular']};
  background-color: transparent;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${`${colors['cyan-text-contrast']}1a`};
  }
`

export const CarouselWrapper = styled.div`
  position: relative;

  .swiper-slide {
    width: auto;
  }

  @media (${media.phone}) {
    margin-left: calc(${space['spacing-md']} * -2);
    margin-right: calc(${space['spacing-md']} * -2);
  }
`

export const Warmer = styled.div`
  position: absolute;
  inset: 0;
  overflow: hidden;
  visibility: hidden;
  pointer-events: none;
`
